import { z } from "zod";
import type { GroupedSmartSurveyorElement } from "components/SmartSurveyor/ReviewPage/types";
import { FORM_DEFAULT_VALUES } from "./elementInspectorForm/constants";
import { NOTE_CONTENT_MAX_LENGTH } from "./ElementNote/constants";
import type { ElementInspectorFormValues } from "./elementInspectorForm/types";
import { PositionSchemaMessages } from "./types";

export function createPositionSchema(messages: PositionSchemaMessages) {
  const finiteNumber = z.number().refine(Number.isFinite, {
    message: messages.bbox,
  });

  return z.object({
    bbox: z.object({
      x1: finiteNumber,
      y1: finiteNumber,
      x2: finiteNumber,
      y2: finiteNumber,
    }),
    group_id: z.string().min(1, { message: messages.groupId }),
    multiplier: z.number().int().min(1, { message: messages.multiplier }),
    note: z.string().max(NOTE_CONTENT_MAX_LENGTH),
  });
}

export function getFormDefaultValues(
  element: GroupedSmartSurveyorElement | null,
): ElementInspectorFormValues {
  if (!element) {
    return FORM_DEFAULT_VALUES;
  }
  return {
    bbox: element.bbox,
    group_id: element.group_id ?? "",
    multiplier: element.multiplier,
    note: element.note?.content ?? "",
  };
}
